import { useEffect, useState } from "react";
import { getVideoSession } from "../../utils/helpers/api";
import { useGlobalState } from "../../contexts/GlobalContext";
import { authHelper } from "../../utils/helpers";
import { useParams } from "react-router-dom";

const SessionVideo: React.FC = () => {
  const [state, setState] = useState<IEventSessionVideo>({
    ondemand: false,
    sesssion: {
      video_available_at: "",
      video_disable_at: "",
        video_player_tag: "",
    //   video_player_tag: `<iframe style="display:block;border:none;margin-left:auto;margin-right:auto;" src="https://players.brightcove.net/3920115937001/experience_67d8ce0424e3b5b868db2a29/index.html" allow="autoplay; fullscreen; geolocation; encrypted-media" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>`,
    },
  });
  const [visibilityFlags, setVisibilityFlags] = useState({
    shouldShowBeforeAvailable: false,
    shouldShowAvailableNoPlayer: false,
    shouldShowVideo: false,
    shouldShowExpired: false,
  });
  const {
    shouldShowBeforeAvailable,
    shouldShowAvailableNoPlayer,
    shouldShowVideo,
    shouldShowExpired,
  } = visibilityFlags;
  const { ondemand, sesssion } = state;
  const { globalState, setStateValue } = useGlobalState();
  const { session_id } = useParams<{ session_id: string }>();
  let isReady = true;

  const handleGetVideoSession = async () => {
    if (!session_id) return;
    const acessToken = authHelper.accessToken();

    setStateValue("loader", true);

    try {
      const result = await getVideoSession(acessToken, session_id);

      if (result.statusCode === 200) {
        isReady = true;
        setState((preState) => ({
          ...preState,
          ondemand: result.data.ondemand,
          sesssion: {
            video_available_at: result.data.session.video_available_at,
            video_disable_at: result.data.session.video_disable_at,
            video_player_tag: result.data.session.video_player_tag,
          },
        }));
      }
    } catch (err) {
      return err;
    } finally {
      setStateValue("loader", false);
    }
  };
    const checkVideoSession = async () => {
    const now = new Date();
    const availableAt = new Date(sesssion?.video_available_at || "");
    const disableAt = new Date(sesssion?.video_disable_at || "");
    const hasPlayer = !!sesssion?.video_player_tag;

    const shouldShowBeforeAvailable = !!ondemand && availableAt > now;

    const shouldShowAvailableNoPlayer =
      !!ondemand && availableAt <= now && now < disableAt && !hasPlayer;

    const shouldShowVideo =
      !!ondemand && availableAt <= now && now < disableAt && hasPlayer;

    const shouldShowExpired = !!ondemand && disableAt < now;

    setVisibilityFlags({
      shouldShowBeforeAvailable,
      shouldShowAvailableNoPlayer,
      shouldShowVideo,
      shouldShowExpired,
    });
  }

  useEffect(() => {
    handleGetVideoSession();
  }, [session_id]);
  useEffect(() => {
    checkVideoSession();
}, [sesssion, ondemand]);
  useEffect(() => {
    const iframe = document.querySelector(
      ".video-wrapper iframe"
    ) as HTMLIFrameElement;
    if (iframe) {
      iframe.style.top = "0";
      iframe.style.left = "0";
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.style.margin = "0";
    }
  }, [sesssion?.video_player_tag]);


  if (!isReady || !ondemand) {
    return (
      <div style={centerStyle}>
        <p style={textStyle}>パスが正しくありません</p>
      </div>
    );
  }

  if (shouldShowBeforeAvailable) {
    return (
      <div style={centerStyle}>
        <p style={textStyle}>
          セミナー・資料 公開前。公開までしばらくお待ちください。
        </p>
      </div>
    );
  }

  if (shouldShowAvailableNoPlayer) {
    return (
      <div style={centerStyle}>
        <p style={textStyle}>
          本講演は、準備中です。公開までしばらくお待ちください。
        </p>
      </div>
    );
  }

  if (shouldShowExpired) {
    return (
      <div style={centerStyle}>
        <p style={textStyle}>本講演は、公開終了いたしました。</p>
      </div>
    );
  }

  if (shouldShowVideo) {
    return (
      <div className="video-wrapper">
        <div
          className="video-inner"
          dangerouslySetInnerHTML={{ __html: sesssion?.video_player_tag || "" }}
        />
      </div>
    );
  }

  return (
    <div style={centerStyle}>
      <p style={textStyle}>現在、利用可能なビデオはありません。{}</p>
    </div>
  );
};

const centerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "60vh",
  textAlign: "center" as const,
};

const textStyle = {
  fontSize: "18px",
};

export default SessionVideo;
